import script from "./UAvatar.vue?vue&type=script&setup=true&lang=ts"
export * from "./UAvatar.vue?vue&type=script&setup=true&lang=ts"

import "./UAvatar.vue?vue&type=style&index=0&id=d0a15334&lang=css"

const __exports__ = script;

export default __exports__